import { Flex, Text } from '@rover/kibble/core';
import theme from '@rover/kibble/tokens/build/rover/es6/theme';
import { TrainerFlairSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/trainerFlairSlugEnum';

import { getFlairIconBySlug } from './utils';

interface TrainerFlairProps {
  slug: TrainerFlairSlugEnum;
  displayText: string;
}
export default function TrainerFlair({ slug, displayText }: TrainerFlairProps): JSX.Element {
  const FlairIcon = getFlairIconBySlug(slug);

  return (
    <Flex
      data-testid="trainer-flair"
      sx={{ padding: '4px 6px' }}
      backgroundColor={theme.colors.green['100']}
      borderRadius="4px"
      gap="8px"
      alignItems="center"
      width="fit-content"
    >
      <FlairIcon height="18px" />
      <Text size="100" fontWeight="semibold" textColor="primary">
        {displayText}
      </Text>
    </Flex>
  );
}
